import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  MenuItem,
  Select,
  TextField,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
} from "@mui/material";
import toast from "react-hot-toast";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import TableBodies from "../../components/table/TableBodies";
import { useTranslation } from "react-i18next";

import { editFolder, folderDelete, folderFlagOff, getFolders } from "../../redux/actions/FileFolder";
import {
  unPairedScreen,
  pairedScreen,
  getAllScreenById,
  getOneScreen,
  registerScreen,
  registerScreenFlagOff,
  updateScreen,
  screenMoveToFolder,
  resetScreenError,
} from "../../redux/actions/Screen";
import { setFolderId } from "../../redux/actions/FileFolder";
import ConfirmationModel from "../../components/confirmmodel/ConfirmationModel";
import Circularbar from "../../components/circularbar/Circularbar";
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";
import { useSettings } from "src/hooks/use-settings";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";
import Stack from "@mui/material/Stack";
import { api } from "src/api/endpoints";
// icons
import FolderIcon from "@mui/icons-material/Folder";
import { FaTrash } from "react-icons/fa";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Player from "./components/Player";
import QuickScreenPairingDialog from "./components/QuickScreenPairingDialog";
import { UpdateScreenModal } from "./components/ScreenPairModal";
import RedesignPlayer from "./components/RedesignPlayer";

function RedesignScreens({ socketRef, user }) {
  const { t } = useTranslation();
  const settings = useSettings();
  const navigate = useNavigate()

  const dispatch = useDispatch();
  const { folderId } = useParams();

  // ---------------------- SELECTORS ------------------------------
  const { delMac, isDeleting, screen, isFindScreen, updatedScreen, isPaired, isUnpaired, isScreenRegistered, duplicateNamesError, screenError } = useSelector((state) => state.Screen);

  // userFolders: state.FileFolder.userFolders.filter((f) => f.parent === state.FileFolder.currentFolder && f.folderFor === "screen"),
  const { currentFolder, currentFolderData, screenFolders, allScreenFolders, screens, allScreens, isFolderCreated, isFolderDeleted, playlists, content } = useSelector(
    (state) => ({
      currentFolder: state.FileFolder.currentFolder,
      currentFolderData: state.FileFolder.userFolders.find((f) => f._id === state.FileFolder.currentFolder),
      screenFolders: state.FileFolder.userFolders.filter((f) => f.parent === state.FileFolder.currentFolder && f.folderFor === "screen"),
      allScreenFolders: state.FileFolder.userFolders.filter((f) => f.folderFor === "screen"),
      screens: state.Screen.screens.filter((s) => s.folderId == state.FileFolder.currentFolder),
      allScreens: state.Screen.screens,
      isFolderCreated: state.FileFolder.isFolderCreated,
      isFolderDeleted: state.FileFolder.isFolderDeleted,
      playlists: state.Playlist.playlists.filter((f) => f.content[0]?.purpose !== "asset"),
      content: state.Content.content,
    }),
    shallowEqual
  );

  // console.log(playlists);
  // console.log("[ES]", currentFolder, currentFolderData, allScreens);
  // const { userFolders } = useSelector(
  //   (state) => ({
  //     userFolders: state.FileFolder.userFolders.filter(
  //       (f) =>
  //         f.parent === state.FileFolder.currentFolder &&
  //         f?.folderFor === "screen"
  //     ),
  //   }),
  //   shallowEqual
  // );
  useEffect(() => {
    // console.log("[ES]", folderId);
    dispatch(setFolderId(folderId || "root"));
  }, [folderId]);
  // useEffect(() => {
  //   console.log("allScreenFolders", allScreenFolders);
  //   console.log("currentFolder", currentFolder);
  //   console.log("folderId", folderId);
  //   if (allScreenFolders && currentFolder && folderId) {
  //     if (
  //       currentFolder === "root" ||
  //       !currentFolder ||
  //       !allScreenFolders.some((folder) => folder._id === currentFolder)
  //     ) {
  //       dispatch(setFolderId("root"));
  //     } else {
  //       allScreenFolders.some((folder) => folder._id === currentFolder) &&
  //         dispatch(setFolderId(folderId || "root"));
  //     }
  //   }
  // }, [allScreenFolders, folderId]);
  // ---------------------- STATES ------------------------------
  const [oneScreen, setOneScreen] = useState({});
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [rowId, setRowId] = useState("");
  const macRef = useRef();
  //123
  const [playlistId, setPlaylistId] = useState("");
  const [screenId, setScreenId] = useState("");
  const [folderVal, setFolderVal] = useState("");
  const [folderName, setFolderName] = useState("");
  const [ids, setIds] = useState("");
  const [openMoveModel, setOpenMoveModel] = useState(false);
  const [openCreateModel, setOpenCreateModel] = useState(false);
  const [openPairedModel, setOpenPairedModel] = useState(false);
  const [openFolderEditModel, setOpenFolderEditModel] = useState(false);
  const [player, setPlayer] = useState({});
  const [openPlayer, setOpenPlayer] = useState(false);
  const [intervalID, setIntervalID] = useState(null);
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [openSelectFiles, setOpenSelectFiles] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const [openPairScreenModelTest, setOpenPairScreenModelTest] = useState(false);
  const [screenFilters, setScreenFilters] = useState({page: 0, name: '', status: '', folderId: ''})
  const [tags, setTags] = useState();

  const [openQuickScreenPairModal, setOpenQuickScreenPairModal] = useState(false)
  const [openPairingScreenModal, setOpenPairingScreenModal] = useState(false)
  const [editingScreen, setEditingScreen] = useState(null)
  const [openConnectedDevicesDialog, setOpenConnectedDevicesDialog] = useState(false)
  const [connectedDevices, setConnectedDevices] = useState([])
  const [connectedDevicesLoading, setConnectedDevicesLoading] = useState(false)

  const [playerv2, setPlayerv2] = useState({open: false, playlist: null});
  // ---------------------- UseEffect ------------------------------

  const urlParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    if(urlParams.get('playlistId')){
      dispatch(getAllScreenById(user?._id, urlParams.get('playlistId')));
    }
    dispatch(getFolders(user?._id));
    setScreenFilters({...screenFilters, folderId: folderId})
  }, []);

  useEffect(() => {
    const loadConnectedDevices = async () => {
      if (!openConnectedDevicesDialog) {
        return;
      }

      setConnectedDevicesLoading(true);
      try {
        const response = await api.get('/screen/connectedDevices');
        setConnectedDevices(response?.data?.data || []);
      } catch (error) {
        toast.error(error?.response?.data?.error || t("views.redesignScreens.serverErr"));
      } finally {
        setConnectedDevicesLoading(false);
      }
    };

    loadConnectedDevices();
  }, [openConnectedDevicesDialog, t]);


  useEffect(() => {
    dispatch(getAllScreenById(user?.id, urlParams.get('playlistId'), screenFilters.page, screenFilters.status, screenFilters.name, screenFilters.folderId))
  }, [screenFilters])

  useEffect(() => {
    if (screenError) {
      switch(screenError) {
          case 'serverError':
              toast.error(t("views.scheduler.serverErr"))
              dispatch(resetScreenError())
              break
          case 'screenNotFound':
              toast.error(t("views.redesignScreens.screenNotFound"))
              dispatch(resetScreenError())
              break
          case 'duplicate':
              toast.error(t("views.scheduler.duplicateError"))
              dispatch(resetScreenError())
              break
          case 'badRequest':
            toast.error(t("views.redesignScreens.badRequestErr"))
            dispatch(resetScreenError())
            break
      }
    }
  }, [screenError])

//   const allScreensData = useMemo(() => {
//     return allScreens
//   }, [allScreens])


  const onScreenMove = (id) => {
    setScreenId(id);
    setOpenMoveModel(true);
  };

  const moveOnFolder = () => {
    dispatch(screenMoveToFolder({ id: screenId, folderId: folderVal }));
    setFolderVal("");
    setOpenMoveModel(false);
    if(folderVal == 'root') {
      navigate('/screen')
    }else {
      navigate(`/screenfolders/${folderVal}`)
    }
  };

  const onScreenFolderDelete = (id) => {
    const childrenscreenfolders = allScreenFolders.filter((f) => f.parent === id) ?? [];
    const childrenscreens = allScreens.filter((s) => s.folderId === id) ?? [];
    if (childrenscreenfolders.length == 0 && childrenscreens.length == 0) {
      setIds(id);
      setOpenCreateModel(true);
    } else {
      toast.error(t("views.redesignScreens.folderContainsItemsError"));
    }
  };

  const onConfirm = () => {
    setOpenCreateModel(false);
    dispatch(folderDelete(ids));
  };

  const onFolderEdit = (id, name) => {
    setIds(id);
    setFolderName(name);
    setOpenFolderEditModel(true);
  };

  const onConfirmFolderEdit = () => {
    if (folderName === "") {
      toast.error(t("views.redesignScreens.fillFolderName"));
    } else {
      dispatch(editFolder(ids, folderName));
      setOpenFolderEditModel(false);
    }
  };

  // ---------------------- SOCKET ------------------------------
  const emitOnAddScreen = () => {
    const plylist = playlists.find((p) => p._id === playlistId);
    for (const p in plylist?.screen_mac) {
      socketRef?.current.emit("screen_added", {
        detail: { mac: plylist?.screen_mac[p]?.mac },
      });
    }
  };

  const onSyncScreen = (_mac) => {
    const relaventScreen = allScreens.find((s) => s.mac === _mac);
    socketRef?.current?.emit("sync", { detail: { mac: _mac } }, function () {
      console.log("succesful sync");
    });
  };

  const onSyncScreenWithToast = (_mac, toast) => {
    const relevantScreen = allScreens.find((s) => s.mac === _mac);

    if (socketRef?.current) {
      socketRef.current.emit("sync", { detail: { mac: _mac } }, function () {
        if (toast && typeof toast.success === "function") {
          toast.success(t("views.redesignScreens.syncSuccess"), {
            deviceName: relevantScreen?.deviceName,
          });
        } else {
          console.log("Sync successful", {
            deviceName: relevantScreen?.deviceName,
          });
        }
      });
    } else {
      console.error("socketRef.current is not available");
    }
  };

  const isObjectEmpty = (obj) => {
    return Object.keys(obj).length === 0;
  };

  const PlayerBox = (objectPlay) => {
    setPlayer({ ...objectPlay });
  };

  const onPlaylistPreview = (screenplaylist) => {
    let playerContentList = [];
    if (isObjectEmpty(screenplaylist)) {
      playerContentList = [];
    } else {
      setOpenPlayer(true);

      let counter = 0;
      const _playlistContent = screenplaylist?.playlist?.content?.filter((p) => p?.content !== null);
      if (_playlistContent !== undefined || _playlistContent !== null) {
        _playlistContent?.forEach((player) => {
          playerContentList.push({
            oriantation: screenplaylist?.oriantation || "landscape",
            name: player.content.name,
            url: player.content.url,
            duration: player.duration,
            type: player.content.type,
            widget: player.content.widget,
          });
        });
      }

      const nextPlay = () => {
        if (counter < playerContentList.length && playerContentList.length > 0) {
          const contentPlay = playerContentList[counter];
          PlayerBox(contentPlay);
          counter++;
          setIntervalID(setTimeout(nextPlay, contentPlay.duration));
        } else {
          if (playerContentList.length > 0) {
            counter = 0;
            nextPlay();
          }
        }
      };
      nextPlay();
    }
  };

  const closePlayer = () => {
    clearTimeout(intervalID);
    onPlaylistPreview({});
    setPlayer({});
    setOpenPlayer(false);
  };

  const onEditScreen = (scr) => {
    setOpenPairingScreenModal(true)
    setEditingScreen(scr)
  }

  return (
    <Fragment>
      <input ref={macRef} value={delMac} hidden />
      <Layout title={t("views.redesignScreens.screens")} user={user} playlistAddBtn={false}>
        <Box component="main" sx={{ flexGrow: 1, py: 2 }}>
          <Container maxWidth={settings.stretch ? false : "xl"}>
            <Grid container spacing={{ xs: 3, lg: 4 }}>
              <Grid xs={12}>
                <Stack direction="row" justifyContent="space-between" spacing={4}>
                  <div>{/* <Typography variant="h4">{t("views.redesignScreens.screens")}</Typography> */}</div>
                </Stack>
              </Grid>
              <Box
                sx={{
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                }}>
                {isDeleting && (
                  <Box
                    sx={{
                      height: "100vh",
                      width: "100vw",
                      position: "absolute",
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      zIndex: 10000,
                      background: "rgba(0,0,0,0.5)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}>
                    <Circularbar />
                  </Box>
                )}
                <Box
                  sx={{
                    width: "100%",
                    overflowX: "hidden",
                    borderRadius: "10px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}>
                  <TableBodies
                    dataRows={allScreens}
                    setPlayerv2={setPlayerv2}
                    user={user}
                    currentFolderData={currentFolderData}
                    currentFolderPoint={currentFolder}
                    onEditScreen={onEditScreen}
                    // onEditScreen={screenUpdate}
                    onScreenMove={onScreenMove}
                    onScreenFolderDelete={onScreenFolderDelete}
                    onFolderEdit={onFolderEdit}
                    onSyncScreen={onSyncScreenWithToast}
                    onPlaylistPreview={onPlaylistPreview}
                    screenFilters={screenFilters}
                    setScreenFilters={setScreenFilters}
                    socketRef={socketRef}
                    setOpenQuickScreenPairModal={setOpenQuickScreenPairModal}
                    setOpenPairScreenModel={setOpenPairingScreenModal}
                    onOpenConnectedDevicesDialog={() => setOpenConnectedDevicesDialog(true)}
                    refresh={() => dispatch(getAllScreenById(user?.id, urlParams.get('playlistId'), screenFilters.page, screenFilters.status, screenFilters.name, screenFilters.folderId))}
                  />
                </Box>
              </Box>
            </Grid>
          </Container>
        </Box>
      </Layout>

      {playerv2.open && <RedesignPlayer open={playerv2.open} onClose={() => setPlayerv2({open: false, playlist: null})} playlist={playerv2.playlist} />}

      <QuickScreenPairingDialog open={openQuickScreenPairModal} socketRef={socketRef} onClose={() => setOpenQuickScreenPairModal(false)} />
      <UpdateScreenModal open={openPairingScreenModal} onClose={() => {
        setOpenPairingScreenModal(false)
        setEditingScreen(null)
      }} socketRef={socketRef} screen={editingScreen} />

      <Dialog
        open={openConnectedDevicesDialog}
        onClose={() => setOpenConnectedDevicesDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle sx={{ textAlign: "center" }}>Socket connected devices</DialogTitle>
        <DialogContent>
          {connectedDevicesLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress />
            </Box>
          ) : connectedDevices.length > 0 ? (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>MAC</TableCell>
                  <TableCell>Socket ID</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {connectedDevices.map((device) => (
                  <TableRow key={`${device.mac}-${device.socketId}`}>
                    <TableCell>{device.mac}</TableCell>
                    <TableCell sx={{ wordBreak: "break-all" }}>{device.socketId}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <Box sx={{ py: 4, textAlign: "center" }}>No socket connected devices found.</Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConnectedDevicesDialog(false)}>
            {t("views.redesignScreens.close")}
          </Button>
        </DialogActions>
      </Dialog>

      <ConfirmationModel
        openCreateModel={openCreateModel}
        onClose={() => setOpenCreateModel(false)}
        onConfirm={onConfirm}
        Icon={FaTrash}
        title={t("views.redesignScreens.deleteConfirmation")}
      />

      <Dialog open={openMoveModel} onClose={() => setOpenMoveModel(false)} maxWidth={"lg"}>
        <DialogTitle sx={{ textAlign: "center" }}>{t("views.redesignScreens.selectFolder")}</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              width: "40vw",
              height: "40vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}>
            <Box
              style={{
                width: "100px",
                height: "100px",
                margin: "0 auto",
              }}>
              <FolderIcon
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
            <Box sx={{ margin: "20px 0" }}>
              <Select value={folderVal} onChange={(e) => setFolderVal(e.target.value)} fullWidth>
                {[
                  {
                    _id: "root",
                    name: "Home",
                    folderFor: "content",
                    path: [],
                    parent: "",
                  },
                  ...screenFolders,
                ].map((folders) => (
                  <MenuItem value={folders._id}>{folders.name}</MenuItem>
                ))}
              </Select>
            </Box>

            <DialogActions>
              <Button onClick={() => setOpenMoveModel(false)}>{t("views.redesignScreens.close")}</Button>
              <Button onClick={moveOnFolder} variant={"contained"}>
                {t("views.redesignScreens.update")}
              </Button>
            </DialogActions>
          </Box>
        </DialogContent>
      </Dialog>
{/* 
      <ConfirmationModel
        openCreateModel={openDeleteModel}
        onClose={() => setOpenDeleteModel(false)}
        onConfirm={confirmUnpaired}
        Icon={HelpOutlineIcon}
        title={t("views.redesignScreens.unpairConfirmation")}
      />
      <ConfirmationModel
        openCreateModel={openPairedModel}
        onClose={() => setOpenPairedModel(false)}
        onConfirm={confirmPaired}
        Icon={HelpOutlineIcon}
        title={t("views.redesignScreens.pairConfirmation")}
      /> */}
      <Dialog open={openFolderEditModel} onClose={() => setOpenFolderEditModel(false)}>
        <FormControl component="form" onSubmit={(e) => e.preventDefault()}>
          <DialogTitle style={{ textAlign: "center" }}>{t("views.redesignScreens.editFolder")}</DialogTitle>
          <DialogContent style={{ borderRadius: "50px" }}>
            <Box
              sx={{
                display: "flex",
                gap: "2px",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}>
              <Box style={{ width: "300px", height: "50px", margin: "20px auto" }}>
                <TextField type={"text"} value={folderName} onChange={(e) => setFolderName(e.target.value)} fullWidth />
              </Box>

              <DialogActions>
                <Button onClick={() => setOpenFolderEditModel(false)}>{t("views.redesignScreens.close")}</Button>
                <Button onClick={onConfirmFolderEdit} variant={"contained"} type="submit">
                  {t("views.redesignScreens.save")}
                </Button>
              </DialogActions>
            </Box>
          </DialogContent>
        </FormControl>
      </Dialog>
    </Fragment>
  );
}

export default RedesignScreens;
